import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import './HomePage.css';

// ✅ Moved outside component (fixes ESLint issue)
const transactionMessages = [
  { phone: '0790****02', status: 'APPLIED', time: '20 mins ago' },
  { phone: '0712****45', status: 'APPLIED', time: '45 mins ago' },
  { phone: '0723****89', status: 'APPLIED', time: '1 hour ago' },
  { phone: '0745****12', status: 'APPLIED', time: '2 hours ago' },
  { phone: '0767****34', status: 'APPLIED', time: '3 hours ago' },
  { phone: '0789****56', status: 'APPLIED', time: '5 hours ago' },
  { phone: '0799****78', status: 'APPLIED', time: '8 hours ago' },
  { phone: '0701****90', status: 'APPLIED', time: '12 hours ago' },
  { phone: '0734****23', status: 'APPLIED', time: '1 day ago' },
  { phone: '0756****67', status: 'APPLIED', time: '2 days ago' },
  { phone: '0722****33', status: 'APPLIED', time: '3 days ago' },
  { phone: '0744****56', status: 'APPLIED', time: '4 days ago' },
  { phone: '0766****89', status: 'APPLIED', time: '5 days ago' },
  { phone: '0788****12', status: 'APPLIED', time: '6 days ago' },
  { phone: '0711****34', status: 'APPLIED', time: '1 week ago' },
  { phone: '0733****67', status: 'APPLIED', time: '1 week ago' },
  { phone: '0755****90', status: 'APPLIED', time: '1 week ago' },
  { phone: '0777****23', status: 'APPLIED', time: '2 weeks ago' },
  { phone: '0799****45', status: 'APPLIED', time: '2 weeks ago' },
  { phone: '0700****78', status: 'APPLIED', time: '3 weeks ago' }
];

function HomePage({ data, updateData }) {
  const [loanType, setLoanType] = useState(data.loanType || '');
  const [customAmount, setCustomAmount] = useState(data.loanAmount || '');
  const [currentMessageIndex, setCurrentMessageIndex] = useState(0);
  const [errorMessage, setErrorMessage] = useState('');
  const navigate = useNavigate();

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentMessageIndex((prevIndex) => (prevIndex + 1) % transactionMessages.length);
    }, 2000);

    return () => clearInterval(interval);
  }, []);

  const loanOptions = [
    { type: 'business', label: 'Business Loan', max: 'Ksh 200,000' },
    { type: 'personal', label: 'Personal Loan', max: 'Ksh 130,000' },
    { type: 'emergency', label: 'Emergency Loan', max: 'Ksh 80,000' }
  ];

  const handleContinue = () => {
    if (!loanType && customAmount) {
      setErrorMessage('Please select a loan type first');
      return;
    }
    
    if (!loanType || !customAmount) {
      setErrorMessage('Please select a loan type and enter amount');
      return;
    }

    setErrorMessage('');
    updateData('loanType', loanType);
    updateData('loanAmount', customAmount);
    navigate('/loan-purpose');
  };

  const currentMessage = transactionMessages[currentMessageIndex];

  return (
    <div className="home-page">
      <div className="container">
        <div className="page-header">
          <h1>Loan Application</h1>
          <p>Select your preferred loan type and amount</p>
        </div>

        {/* Rotating Transaction Messages */}
        <div className="transaction-feed">
          <div className="transaction-message">
            <span className="money-icon">💰</span>
            <div className="transaction-details">
              <div className="transaction-line">
                {currentMessage.phone} {currentMessage.status}
              </div>
              <div className="transaction-time">
                • {currentMessage.time}
              </div>
            </div>
          </div>
        </div>

        <div className="loan-types">
          {loanOptions.map((option) => (
            <div
              key={option.type}
              className={`loan-option ${loanType === option.type ? 'selected' : ''}`}
              onClick={() => {
                setLoanType(option.type);
                setErrorMessage('');
              }}
            >
              <div className="loan-icon">
                {option.type === 'business' ? '💼' :
                 option.type === 'personal' ? '👤' : '🚨'}
              </div>
              <div className="loan-info">
                <h3>{option.label}</h3>
                <p>Up to {option.max}</p>
              </div>
            </div>
          ))}
        </div>

        <div className="amount-section">
          <label htmlFor="loanAmount">Enter Loan Amount (Ksh)</label>
          <input
            type="number"
            id="loanAmount"
            value={customAmount}
            onChange={(e) => {
              setCustomAmount(e.target.value);
              setErrorMessage('');
            }}
            placeholder="Enter amount..."
          />
        </div>

        {errorMessage && (
          <div className="error-message" style={{
            color: '#dc3545',
            backgroundColor: '#f8d7da',
            padding: '12px',
            borderRadius: '8px',
            marginBottom: '15px',
            textAlign: 'center',
            fontWeight: '500'
          }}>
            {errorMessage}
          </div>
        )}

        <button
          className="continue-btn"
          onClick={handleContinue}
        >
          Continue
        </button>
      </div>
    </div>
  );
}

export default HomePage;